/* eslint-disable */
import React from 'react';
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  Image,
  ScrollView,
  PermissionsAndroid,
  Dimensions,
  Linking,
  Platform,
  ActivityIndicator,
  TextInput,
} from 'react-native';
import ScreenWrapper from '../../components/ScreenWrapper';
import PrimaryButton from '../../components/PrimaryButton';
import InputWrapper from '../../components/InputWrapper';
import ScanReceiptView from '../../components/ScanReceiptView';
import ReceiptViewerModal from '../../components/ReceiptViewerModal';
import {
  FuelPriceChips,
  FuelPriceList,
} from '../../components/StationFuelPrices';
import {formatFuelPrice, getFuelOfferings} from '../../utility/fuelOfferings';
import MapView, {Polyline, Callout, CalloutSubview} from 'react-native-maps';
import {Marker} from 'react-native-maps';
import {useEffect, useState, useRef, useMemo, useCallback} from 'react';
import Geolocation from 'react-native-geolocation-service';
import {
  fetchRouteOptions,
  formatDistance,
  getLabelPoints,
} from './directions';
import {getGasStations, showGasStations} from '../../slice/gasStationSlice';
import {visibleStations} from '../../utility/visibleStations';
import {useDispatch, useSelector} from 'react-redux';
import {
  updatePrice,
  getStationDetails,
  saveStation,
  removeStation,
} from '../../services/auth-service';
import Toast from 'react-native-toast-message';
import {useTranslation} from 'react-i18next';
import Svg, {Path} from 'react-native-svg';
import PompiGreenLight from '../../assets/icons/light_green_pump.svg';
import BookmarkIcon from '../../assets/Bookmark.svg';
import ChevronLeft from '../../assets/icons/chevron-left.svg';
import {
  card,
  colors,
  fonts,
  radii,
  shadows,
  spacing,
  typography,
} from '../../config/theme';
import BottomSheet, {
  BottomSheetFlatList,
  BottomSheetScrollView,
  BottomSheetBackdrop,
} from '@gorhom/bottom-sheet';
import {GestureHandlerRootView} from 'react-native-gesture-handler';
import Animated, {
  useAnimatedStyle,
  useSharedValue,
} from 'react-native-reanimated';
import {SafeAreaView, useSafeAreaInsets} from 'react-native-safe-area-context';
const {height: screenHeight} = Dimensions.get('window');
import StartMarker from '../../assets/icons/start-marker.svg';
import DefaultMarker from '../../assets/icons/default-marker.svg';
import PinPetrol from '../../assets/icons/pin-petrol.svg';
import PinEv from '../../assets/icons/pin-ev.svg';
import PinHybrid from '../../assets/icons/pin-hybrid.svg';
import PinCheapest from '../../assets/icons/pin-cheapest.svg';
import SwapIcon from '../../assets/icons/swap.svg';

// Minimal fuel-nozzle glyph (Material "local_gas_station") for station pins.
const FuelGlyph = ({size = 20, color = colors.primary}) => (
  <Svg width={size} height={size} viewBox="0 0 24 24">
    <Path
      fill={color}
      d="M19.77 7.23l.01-.01-3.72-3.72L15 4.56l2.11 2.11c-.94.36-1.61 1.26-1.61 2.33 0 1.38 1.12 2.5 2.5 2.5.36 0 .69-.08 1-.21v7.21c0 .55-.45 1-1 1s-1-.45-1-1V14c0-1.1-.9-2-2-2h-1V5c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v16h10v-7.5h1.5v5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V9c0-.69-.28-1.32-.73-1.77zM12 10H6V5h6v5zm6 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
    />
  </Svg>
);

// Material icon paths for the route controls and station details.
const GLYPHS = {
  call: 'M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 00-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z',
  directions:
    'M21.71 11.29l-9-9a.996.996 0 00-1.41 0l-9 9a.996.996 0 000 1.41l9 9c.39.39 1.02.39 1.41 0l9-9a.996.996 0 000-1.41zM14 14.5V12h-4v3H8v-4c0-.55.45-1 1-1h5V7.5l3.5 3.5-3.5 3.5z',
  scan: 'M7 3H4v3H2V1h5v2zm15 3V1h-5v2h3v3h2zM7 21H4v-3H2v5h5v-2zm13-3v3h-3v2h5v-5h-2zM19 18c0 1.1-.9 2-2 2H7c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2v12zM15 8H9v2h6V8zm0 3H9v2h6v-2zm0 3H9v2h6v-2z',
  star: 'M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z',
  verified:
    'M23 12l-2.44-2.79.34-3.69-3.61-.82-1.89-3.2L12 2.96 8.6 1.5 6.71 4.69 3.1 5.5l.34 3.7L1 12l2.44 2.79-.34 3.7 3.61.82L8.6 22.5l3.4-1.47 3.4 1.46 1.89-3.19 3.61-.82-.34-3.69L23 12zm-12.91 4.72l-3.8-3.81 1.48-1.48 2.32 2.33 5.85-5.87 1.48 1.48-7.33 7.35z',
  website:
    'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95a15.65 15.65 0 00-1.38-3.56A8.03 8.03 0 0118.92 8zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2 0 .68.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56A7.987 7.987 0 015.08 16zm2.95-8H5.08a7.987 7.987 0 014.33-3.56A15.65 15.65 0 008.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2 0-.68.07-1.35.16-2h4.68c.09.65.16 1.32.16 2 0 .68-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95a8.03 8.03 0 01-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2 0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z',
  car: 'M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z',
  myLocation:
    'M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3A8.994 8.994 0 0013 3.06V1h-2v2.06A8.994 8.994 0 003.06 11H1v2h2.06A8.994 8.994 0 0011 20.94V23h2v-2.06A8.994 8.994 0 0020.94 13H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z',
  navigate: 'M12 2L4.5 20.29l.71.71L12 18l6.79 3 .71-.71z',
  overview:
    'M15 3l2.3 2.3-2.89 2.87 1.42 1.42L18.7 6.7 21 9V3h-6zM3 9l2.3-2.3 2.87 2.89 1.42-1.42L6.7 5.3 9 3H3v6zm6 12l-2.3-2.3 2.89-2.87-1.42-1.42L5.3 17.3 3 15v6h6zm12-6l-2.3 2.3-2.87-2.89-1.42 1.42 2.89 2.87L15 21h6v-6z',
};

const Glyph = ({name, size = 20, color = colors.primary}) => (
  <Svg width={size} height={size} viewBox="0 0 24 24">
    <Path fill={color} d={GLYPHS[name]} />
  </Svg>
);

// Route line styling: the selected route is drawn last, in the brand's
// "live route" green over a deep outline; alternatives sit underneath, muted,
// and can be tapped to switch, like Google Maps.
const ROUTE_WIDTH = 6;
const ROUTE_OUTLINE_WIDTH = 10;
const ALT_ROUTE_COLOR = '#9DB8AE';
// Fill of the end pin artwork (default-marker.svg), echoed in the header.
const MAP_END_RED = '#EA352B';
// Ring colour of pin-cheapest.svg, echoed in its halo and price bubble.
const CHEAPEST_RED = '#DC2626';

// Room the floating header and the collapsed sheet take over the map, so
// fitted routes land in the visible part.
const HEADER_CLEARANCE = 200;
// Below this zoom (latitudeDelta) station pins shrink to dots so the route
// stays readable, the way Google Maps thins out POIs when zoomed out.
const DETAIL_ZOOM_DELTA = 0.12;
const SHEET_COLLAPSED = 0.32;
// Height of the sheet's drag handle (the library default), added to the
// measured header so the lowest snap point shows just the header.
const SHEET_HANDLE_HEIGHT = 24;

// Map pin geometry is fixed so Android marker snapshots never clip.
const PIN_SIZE = 40;
// Same pin artwork, shrunk, when zoomed out past DETAIL_ZOOM_DELTA.
const DOT_PIN_SIZE = 24;

// Picks the map pin from the station's Google Places types; anything that
// isn't tagged as an EV charger is shown as a petrol station.
const getStationPin = station => {
  const types = station?.types || [];
  const ev = types.includes('electric_vehicle_charging_station');
  if (ev && types.includes('gas_station')) {
    return PinHybrid;
  }
  return ev ? PinEv : PinPetrol;
};
const PRICE_BUBBLE_HEIGHT = 20;
const PIN_STACK_WIDTH = 76;

// "4.9 km" driven from the start of the route to this pump, or null when the
// backend didn't send it (it is km either way; distanceFromStartMiles is miles).
const alongRouteText = station =>
  typeof station?.distanceAlongRouteMeters === 'number'
    ? formatDistance(station.distanceAlongRouteMeters)
    : null;

// maps/gas-stations sends recieptUrl as a string; older responses sent {url}.
const receiptLink = station =>
  typeof station?.recieptUrl === 'string'
    ? station.recieptUrl
    : station?.recieptUrl?.url || null;

// Straight-line distance between two points, in km
const calculateDistance = (lat1, lon1, lat2, lon2) => {
  const R = 6371; // Radius of the Earth in kilometers
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLon = ((lon2 - lon1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c;
  return distance;
};

// "Updated 3 hours ago" for a price timestamp (ms, as number or string).
const getTimeAgo = (timestamp, t) => {
  if (!timestamp) return '';

  const now = new Date().getTime();
  const createdAt =
    typeof timestamp === 'string' ? parseInt(timestamp) : timestamp;
  const diffInMs = now - createdAt;
  const diffInSeconds = Math.floor(diffInMs / 1000);
  const diffInMinutes = Math.floor(diffInSeconds / 60);
  const diffInHours = Math.floor(diffInMinutes / 60);
  const diffInDays = Math.floor(diffInHours / 24);
  const diffInMonths = Math.floor(diffInDays / 30);
  const diffInYears = Math.floor(diffInDays / 365);

  if (diffInYears > 0) {
    return `${t('root.PumpSearch.UpdatedAgo.Updated')} ${diffInYears} ${
      diffInYears === 1
        ? t('root.PumpSearch.UpdatedAgo.Years')
        : t('root.PumpSearch.UpdatedAgo.YearsPlural')
    } ${t('root.PumpSearch.UpdatedAgo.Ago')}`;
  } else if (diffInMonths > 0) {
    return `${t('root.PumpSearch.UpdatedAgo.Updated')} ${diffInMonths} ${
      diffInMonths === 1
        ? t('root.PumpSearch.UpdatedAgo.Months')
        : t('root.PumpSearch.UpdatedAgo.MonthsPlural')
    } ${t('root.PumpSearch.UpdatedAgo.Ago')}`;
  } else if (diffInDays > 0) {
    return `${t('root.PumpSearch.UpdatedAgo.Updated')} ${diffInDays} ${
      diffInDays === 1
        ? t('root.PumpSearch.UpdatedAgo.Days')
        : t('root.PumpSearch.UpdatedAgo.DaysPlural')
    } ${t('root.PumpSearch.UpdatedAgo.Ago')}`;
  } else if (diffInHours > 0) {
    return `${t('root.PumpSearch.UpdatedAgo.Updated')} ${diffInHours} ${
      diffInHours === 1
        ? t('root.PumpSearch.UpdatedAgo.Hours')
        : t('root.PumpSearch.UpdatedAgo.HoursPlural')
    } ${t('root.PumpSearch.UpdatedAgo.Ago')}`;
  } else if (diffInMinutes > 0) {
    return `${t('root.PumpSearch.UpdatedAgo.Updated')} ${diffInMinutes} ${
      diffInMinutes === 1
        ? t('root.PumpSearch.UpdatedAgo.Minutes')
        : t('root.PumpSearch.UpdatedAgo.MinutesPlural')
    } ${t('root.PumpSearch.UpdatedAgo.Ago')}`;
  } else {
    return t('root.PumpSearch.UpdatedAgo.JustUpdated');
  }
};

// Amenity labels for a station card, only for what the backend confirms.
const getAmenityLabels = (station, t) => {
  const labels = [];
  const pay = station?.paymentOptions;
  if (pay?.creditCards || pay?.debitCards) {
    labels.push(t('root.PumpSearch.Amenities.Cards'));
  }
  if (pay?.nfc) {
    labels.push(t('root.PumpSearch.Amenities.Contactless'));
  }
  if (pay?.cashOnly) {
    labels.push(t('root.PumpSearch.Amenities.CashOnly'));
  }
  const amenities = station?.amenities;
  if (amenities?.restroom?.dataAvailable && amenities.restroom.available) {
    labels.push(t('root.PumpSearch.Amenities.Restroom'));
  }
  const parking = amenities?.parking;
  if (
    parking?.dataAvailable &&
    (parking.freeParking || parking.paidParking || parking.freeStreetParking)
  ) {
    labels.push(t('root.PumpSearch.Amenities.Parking'));
  }
  if (amenities?.accessibility?.wheelchairAccessible) {
    labels.push(t('root.PumpSearch.Amenities.Wheelchair'));
  }
  return labels;
};

// One row of the pump list. Memoised so scrolling or panning the map doesn't
// re-render rows whose pump hasn't changed (the handlers are stable).
const StationListItem = React.memo(function StationListItem({
  station,
  isCheapest,
  isNearest,
  isSelected,
  onPress,
  onDirections,
  onBookmark,
  onViewReceipt,
}) {
  const {t} = useTranslation();
  const receipt = receiptLink(station);
  const price = formatFuelPrice(
    station.latestPrice || station.estimatedPrice,
  );
  const fuel = station.selectedFuel;
  const ahead = alongRouteText(station);
  const ev = station?.offerings?.evCharging;
  const hasEv = !!(ev?.dataAvailable && ev.available);
  const offerings = useMemo(() => getFuelOfferings(station), [station]);
  const amenities = getAmenityLabels(station, t);
  const canNavigate = !!(station.location?.lat && station.location?.lng);
  const initial = (station.name || '?').trim().charAt(0).toUpperCase();

  return (
    <TouchableOpacity
      style={[
        styles.stationItem,
        isCheapest && styles.stationItemCheapest,
        isNearest && styles.stationItemNearest,
        isSelected && styles.stationItemSelected,
      ]}
      activeOpacity={0.85}
      onPress={() => onPress(station)}>
      {/* Header: brand tile, name with badges, save pill */}
      <View style={styles.cardHeader}>
        <View style={styles.cardAvatar}>
          <Text style={styles.cardAvatarText}>{initial}</Text>
        </View>
        <View style={styles.cardTitleBlock}>
          <View style={styles.cardTitleRow}>
            <Text style={styles.cardName} numberOfLines={2}>
              {station.name}
            </Text>
          </View>
          <View style={styles.cardBadges}>
            {/* Only a receipt-backed price earns the badge; it opens the receipt */}
            {!!receipt && (
              <TouchableOpacity
                style={styles.cardBadge}
                activeOpacity={0.7}
                accessibilityRole="link"
                accessibilityLabel={t('root.PumpSearch.ViewReceipt')}
                onPress={() => onViewReceipt(receipt)}>
                <Text style={styles.cardBadgeText}>
                  {t('root.PumpSearch.Verified')}
                </Text>
              </TouchableOpacity>
            )}
            {isCheapest && (
              <View style={styles.cardBadge}>
                <Text style={styles.cardBadgeText}>
                  {t('root.PumpSearch.CheapestBadge')}
                </Text>
              </View>
            )}
            {isNearest && (
              <View style={[styles.cardBadge, styles.cardBadgeNeutral]}>
                <Text style={[styles.cardBadgeText, styles.cardBadgeTextNeutral]}>
                  {t('root.PumpSearch.NearestBadge')}
                </Text>
              </View>
            )}
          </View>
          <Text style={styles.cardSubtitle} numberOfLines={2}>
            {station.vicinity}
            {!!ahead && (
              <Text style={styles.cardAhead}>
                {' •\u00A0'}
                {/* Non-breaking, so "• 3.4 km ahead" never splits over lines */}
                {t('root.PumpSearch.Ahead', {distance: ahead}).replace(
                  / /g,
                  '\u00A0',
                )}
              </Text>
            )}
          </Text>
        </View>
        <TouchableOpacity
          style={[
            styles.cardSavePill,
            station.isBookmarked && styles.cardSavePillActive,
          ]}
          activeOpacity={0.7}
          accessibilityRole="button"
          onPress={() =>
            onBookmark(station, station.isBookmarked ? 'remove' : 'save')
          }>
          <BookmarkIcon
            width={14}
            height={14}
            stroke={colors.primary}
            fill={station.isBookmarked ? colors.primary : 'transparent'}
          />
          <Text style={styles.cardSavePillText}>
            {station.isBookmarked
              ? t('root.PumpSearch.Saved')
              : t('root.PumpSearch.Save')}
          </Text>
        </TouchableOpacity>
      </View>

      {typeof station.rating === 'number' && station.rating > 0 && (
        <Text style={styles.cardRating}>
          <Text style={styles.cardRatingStar}>★ </Text>
          {station.rating.toFixed(1)}
        </Text>
      )}

      {/* Facts panel: price of the user's fuel (or the latest scan) */}
      <View style={styles.cardPanel}>
        <View style={styles.cardPanelCol}>
          <Text style={styles.cardPanelLabel} numberOfLines={1}>
            {fuel?.name || t('root.PumpSearch.LatestPrice')}
          </Text>
          {price ? (
            <>
              <Text style={styles.cardPanelValue} numberOfLines={1}>
                €{price}
                <Text style={styles.cardPanelUnit}> /{fuel?.unit || 'L'}</Text>
              </Text>
              {!!station.createdAt && (
                <View style={styles.cardPanelChip}>
                  <Text style={styles.cardPanelChipText} numberOfLines={1}>
                    {getTimeAgo(station.createdAt, t)}
                  </Text>
                </View>
              )}
            </>
          ) : (
            <>
              <Text style={[styles.cardPanelValue, styles.cardPanelValueMuted]}>
                –
              </Text>
              <Text style={styles.cardPanelSub} numberOfLines={1}>
                {t('root.PumpSearch.NoPriceShort')}
              </Text>
            </>
          )}
        </View>
        {typeof station.distanceFromRouteMeters === 'number' && (
          <>
            <View style={styles.cardPanelDivider} />
            <View style={styles.cardPanelCol}>
              <Text style={styles.cardPanelLabel} numberOfLines={1}>
                {t('root.PumpSearch.OffRoute')}
              </Text>
              <Text style={styles.cardPanelValue} numberOfLines={1}>
                {formatDistance(station.distanceFromRouteMeters)}
              </Text>
            </View>
          </>
        )}
        {hasEv && (
          <>
            <View style={styles.cardPanelDivider} />
            <View style={styles.cardPanelCol}>
              <Text style={styles.cardPanelLabel} numberOfLines={1}>
                {t('root.PumpSearch.EvCharging')}
              </Text>
              <Text
                style={[styles.cardPanelValue, styles.cardPanelValueLive]}
                numberOfLines={1}>
                {ev.connectorCount
                  ? t('root.PumpSearch.Connectors', {count: ev.connectorCount})
                  : t('root.PumpSearch.Available')}
              </Text>
            </View>
          </>
        )}
      </View>

      <FuelPriceChips offerings={offerings} />

      {amenities.length > 0 && (
        <View style={styles.cardAmenities}>
          {amenities.map(label => (
            <Text key={label} style={styles.cardAmenityText}>
              {label}
            </Text>
          ))}
        </View>
      )}

      <View style={styles.cardActions}>
        <TouchableOpacity
          style={[styles.cardButton, styles.cardButtonSecondary]}
          activeOpacity={0.8}
          accessibilityRole="button"
          onPress={() => onPress(station)}>
          <Text style={styles.cardButtonSecondaryText}>
            {t('root.PumpSearch.Details')}
          </Text>
        </TouchableOpacity>
        {canNavigate && (
          <TouchableOpacity
            style={[styles.cardButton, styles.cardButtonPrimary]}
            activeOpacity={0.85}
            accessibilityRole="button"
            onPress={() => onDirections(station)}>
            <Text style={styles.cardButtonPrimaryText}>
              {t('root.PumpSearch.Directions')}
            </Text>
          </TouchableOpacity>
        )}
      </View>
    </TouchableOpacity>
  );
});

// Custom marker views are snapshotted. Track view changes for a moment after
// the look changes (Android needs a frame to draw the SVG), then stop, so
// idle markers cost nothing while the map moves.
const useTrackViewChanges = deps => {
  const [tracks, setTracks] = useState(true);
  useEffect(() => {
    setTracks(true);
    const id = setTimeout(() => setTracks(false), 500);
    return () => clearTimeout(id);
  }, deps);
  return tracks;
};

const StationMarker = React.memo(function StationMarker({
  station,
  isZoomedIn,
  isCheapest,
  isNearest,
  onPress,
  registerRef,
}) {
  const tracks = useTrackViewChanges([
    isZoomedIn,
    isCheapest,
    isNearest,
    station.latestPrice,
  ]);
  const setRef = useCallback(ref => registerRef(station, ref), [
    station,
    registerRef,
  ]);
  const StationPin = isCheapest ? PinCheapest : getStationPin(station);
  return (
    <Marker
      ref={setRef}
      anchor={isZoomedIn ? undefined : {x: 0.5, y: 0.5}}
      zIndex={isCheapest ? 40 : 30}
      tracksViewChanges={tracks}
      onPress={() => onPress(station)}
      coordinate={{
        latitude: station.location.lat,
        longitude: station.location.lng,
      }}>
      {!isZoomedIn ? (
        <View
          style={[
            styles.stationPin,
            isCheapest
              ? styles.stationDotCheapest
              : isNearest
              ? styles.stationDotNearest
              : null,
          ]}>
          <StationPin width={DOT_PIN_SIZE} height={DOT_PIN_SIZE} />
        </View>
      ) : (
        <View style={styles.stationMarker}>
          <View
            style={[
              styles.priceBubble,
              isCheapest && styles.priceBubbleCheapest,
              !station.latestPrice && styles.priceBubbleEmpty,
            ]}>
            {!!station.latestPrice && (
              <Text style={styles.priceBubbleText} numberOfLines={1}>
                €{formatFuelPrice(station.latestPrice)}
              </Text>
            )}
          </View>
          <View
            style={[
              styles.stationPin,
              isCheapest
                ? styles.stationPinCheapest
                : isNearest
                ? styles.stationPinNearest
                : null,
            ]}>
            <StationPin width={PIN_SIZE} height={PIN_SIZE} />
          </View>
        </View>
      )}
      <Callout tooltip={false}>
        <View style={styles.mapCalloutContainer}>
          <View style={styles.mapCalloutHeader}>
            <View style={styles.mapCalloutLogo}>
              <FuelGlyph size={14} color={colors.primary} />
            </View>
            <View style={styles.mapCalloutInfo}>
              <Text style={styles.mapCalloutTitle} numberOfLines={1}>
                {station.name}
              </Text>
              <Text style={styles.mapCalloutAddress} numberOfLines={2}>
                {station.vicinity}
              </Text>
            </View>
          </View>
        </View>
      </Callout>
    </Marker>
  );
});

const MapPumpSearch = ({navigation, route}) => {
  const {t} = useTranslation();
  const insets = useSafeAreaInsets();
  // No tab bar on this screen, so keep the sheet's last row above the home indicator.
  const sheetBottomPadding = {paddingBottom: spacing.xxl + insets.bottom};
  const [coords, setCoords] = useState([]);
  const [selectedStation, setSelectedStation] = useState(null);

  // Get user data from Redux store
  const {userId, token} = useSelector(state => state.login);
  const {
    gasStations: reduxGasStations,
    loading: gasStationsLoading,
    cheapestGasStation: reduxCheapestGasStation,
  } = useSelector(state => state.gasStation);
  const [currentStartLocation, setCurrentStartLocation] = useState(
    route.params?.startLocation || null,
  );
  const [currentEndLocation, setCurrentEndLocation] = useState(
    route.params?.endLocation || null,
  );
  // Fuel chosen on the search screen ('petrol' | 'diesel' | 'lpg' | 'cng' |
  // 'ev'). When it is missing the old maps/gas-stations endpoint is used.
  const fuelType = route.params?.fuelType || null;
  const [isLoadingGasStations, setIsLoadingGasStations] = useState(false);
  const [showStationDetails, setShowStationDetails] = useState(false);
  const [showScanReceipt, setShowScanReceipt] = useState(false);
  const [enteredPrice, setEnteredPrice] = useState('');
  const [receiptUrl, setReceiptUrl] = useState('');
  // Fuel the receipt is for; ScanReceiptView fills in the user's own fuel.
  const [receiptFuelType, setReceiptFuelType] = useState(null);
  const [bookmarkOverrides, setBookmarkOverrides] = useState({});
  // Receipt (image or PDF) shown inside the app instead of a browser
  const [receiptViewerUrl, setReceiptViewerUrl] = useState(null);
  const openReceiptViewer = useCallback(url => {
    if (url) setReceiptViewerUrl(url);
  }, []);
  const closeReceiptViewer = useCallback(() => setReceiptViewerUrl(null), []);
  const [routeOptions, setRouteOptions] = useState([]);
  const [selectedRouteIndex, setSelectedRouteIndex] = useState(0);
  const [isLoadingRoutes, setIsLoadingRoutes] = useState(false);
  const [routeError, setRouteError] = useState(false);
  const [isFollowingUser, setIsFollowingUser] = useState(false);
  const [isZoomedIn, setIsZoomedIn] = useState(false);
  // Last region the map settled on; drives marker culling and thinning.
  const [visibleRegion, setVisibleRegion] = useState(null);
  const visibleRegionRef = useRef(null);
  const lastUserLocation = useRef(null);

  // Debug receiptUrl changes
  useEffect(() => {
    console.log('receiptUrl state changed:', receiptUrl);
  }, [receiptUrl]);

  // Wrapper function to ensure setReceiptUrl is properly bound
  const handleSetReceiptUrl = useCallback(url => {
    console.log('Setting receipt URL:', url);
    setReceiptUrl(url);
  }, []);
  const [stationDetails, setStationDetails] = useState(null);
  const [isLoadingStationDetails, setIsLoadingStationDetails] = useState(false);
  const [activeButton, setActiveButton] = useState(null); // 'cheapest', 'nearest', or null
  const dispatch = useDispatch();

  // Bottom sheet ref and snap points
  const bottomSheetRef = useRef(null);
  // Current snap point: 0 header only, 1 collapsed, 2 expanded.
  const sheetIndexRef = useRef(1);
  const mapRef = useRef(null);
  const markerRefs = useRef({});
  // Snap points: header only (most map), collapsed list, expanded list.
  const [sheetHeaderHeight, setSheetHeaderHeight] = useState(110);
  const [containerHeight, setContainerHeight] = useState(screenHeight);
  const sheetPeekHeight =
    SHEET_HANDLE_HEIGHT + sheetHeaderHeight + insets.bottom;
  const snapPoints = useMemo(
    () => [sheetPeekHeight, `${SHEET_COLLAPSED * 100}%`, '70%'],
    [sheetPeekHeight],
  );
  // Top edge and snap index of the sheet, driven by the sheet while it is
  // dragged (fractional in between snap points).
  const sheetPosition = useSharedValue(screenHeight);
  const sheetAnimatedIndex = useSharedValue(1);
  const sheetBodyStyle = useAnimatedStyle(() => ({
    opacity: Math.min(Math.max(sheetAnimatedIndex.value, 0), 1),
  }));
  // Map controls ride on top of the sheet, but stop at the collapsed height
  // when it is expanded further (the sheet covers them there).
  const mapControlsStyle = useAnimatedStyle(() => {
    const collapsedTop = containerHeight * (1 - SHEET_COLLAPSED);
    const top = Math.max(sheetPosition.value, collapsedTop);
    return {bottom: containerHeight - top + spacing.margin};
  }, [containerHeight]);
  const maxHeight = screenHeight * 0.75;


  const getStationKey = useCallback(station => {
    return station?.id || station?.place_id || station?.placeId;
  }, []);

  // Locally overlay bookmark state so UI updates immediately
  const displayedGasStations = useMemo(() => {
    return reduxGasStations.map(s => {
      const key = getStationKey(s);
      const override = key ? bookmarkOverrides[key] : undefined;
      return override === undefined ? s : {...s, isBookmarked: override};
    });
  }, [reduxGasStations, bookmarkOverrides, getStationKey]);

  // Cheapest comes from the backend; only trust it if it is one of the pumps
  // shown for this route, matched on the same key the markers use.
  const cheapestKey = useMemo(() => {
    const key = getStationKey(reduxCheapestGasStation);
    return key && reduxGasStations.some(s => getStationKey(s) === key)
      ? key
      : null;
  }, [reduxCheapestGasStation, reduxGasStations, getStationKey]);

  // Nearest = the first pump the driver reaches on this route; fall back to
  // straight-line distance from the start if the backend didn't say. Derived
  // from the current list, so it follows route switches and reloads.
  const nearestStation = useMemo(() => {
    if (!currentStartLocation) {
      return null;
    }
    const {latitude: startLat, longitude: startLng} = currentStartLocation;
    let nearest = null;
    let minDistance = Infinity;
    reduxGasStations.forEach(station => {
      const d =
        typeof station?.distanceAlongRouteMeters === 'number'
          ? station.distanceAlongRouteMeters / 1000
          : calculateDistance(
              startLat,
              startLng,
              station?.location?.lat,
              station?.location?.lng,
            );
      if (d < minDistance) {
        minDistance = d;
        nearest = station;
      }
    });
    return nearest;
  }, [currentStartLocation, reduxGasStations]);
  // The nearest halo only shows while the Nearest chip is on.
  const nearestKey =
    activeButton === 'nearest' ? getStationKey(nearestStation) || null : null;

  const selectedRoute = routeOptions[selectedRouteIndex] || null;

  // Pumps belong to the selected route only. Responses are cached per route
  // (keyed by its polyline), so switching back to a route is instant. A new
  // start or end clears the cache and the list.
  const stationCache = useRef(new Map());
  const stationRequest = useRef(0);

  useEffect(() => {
    stationCache.current.clear();
    dispatch(showGasStations(null));
  }, [currentStartLocation, currentEndLocation]);

  const loadStationsForRoute = useCallback(
    async (routeOption, {refresh = false} = {}) => {
      const requestNo = ++stationRequest.current;
      // Same route, different fuel = different prices, so the fuel is part
      // of the cache key.
      const cacheKey = `${fuelType || 'any'}|${routeOption.polyline}`;
      const cached = stationCache.current.get(cacheKey);
      if (cached && !refresh) {
        dispatch(showGasStations(cached));
        setIsLoadingGasStations(false);
        return;
      }
      setIsLoadingGasStations(true);
      try {
        const payload = await dispatch(
          getGasStations({
            sourceLat: currentStartLocation?.latitude,
            sourceLng: currentStartLocation?.longitude,
            destLat: currentEndLocation?.latitude,
            destLng: currentEndLocation?.longitude,
            route: routeOption,
            fuelType,
          }),
        ).unwrap();
        stationCache.current.set(cacheKey, payload);
      } catch (error) {
        console.log('Error fetching gas stations:', error);
        // The previous pumps stay on the map; only this route's request failed.
        if (requestNo === stationRequest.current) {
          Toast.show({
            type: 'error',
            text1: t('root.Toast.Error.RouteStationsFailed'),
          });
        }
      } finally {
        if (requestNo === stationRequest.current) {
          setIsLoadingGasStations(false);
        }
      }
    },
    [currentStartLocation, currentEndLocation, fuelType, dispatch, t],
  );

  useEffect(() => {
    setActiveButton(null);
    if (selectedRoute) {
      loadStationsForRoute(selectedRoute);
    }
  }, [selectedRoute]);
  const routeLabelPoints = useMemo(
    () => getLabelPoints(routeOptions),
    [routeOptions],
  );

  const mapEdgePadding = useMemo(
    () => ({
      top: insets.top + HEADER_CLEARANCE,
      right: 48,
      bottom: screenHeight * SHEET_COLLAPSED + 24,
      left: 48,
    }),
    [insets.top],
  );

  // Frame the whole trip: every route option plus both endpoints.
  const fitRoute = useCallback(
    (options = routeOptions) => {
      const points = options.flatMap(r => r.coordinates);
      if (currentStartLocation) points.push(currentStartLocation);
      if (currentEndLocation) points.push(currentEndLocation);
      if (!mapRef.current || points.length < 2) return;
      setIsFollowingUser(false);
      mapRef.current.fitToCoordinates(
        points.map(({latitude, longitude}) => ({latitude, longitude})),
        {edgePadding: mapEdgePadding, animated: true},
      );
    },
    [routeOptions, currentStartLocation, currentEndLocation, mapEdgePadding],
  );

  useEffect(() => {
    if (!currentStartLocation || !currentEndLocation) return;
    let cancelled = false;
    setIsLoadingRoutes(true);
    setRouteError(false);
    fetchRouteOptions(currentStartLocation, currentEndLocation)
      .then(options => {
        if (cancelled) return;
        setRouteOptions(options);
        setSelectedRouteIndex(0);
        // Let the polylines mount before framing them.
        setTimeout(() => fitRoute(options), 300);
      })
      .catch(error => {
        if (cancelled) return;
        console.log('Error fetching routes:', error);
        setRouteOptions([]);
        setRouteError(true);
      })
      .finally(() => {
        if (!cancelled) setIsLoadingRoutes(false);
      });
    return () => {
      cancelled = true;
    };
  }, [currentStartLocation, currentEndLocation]);

  // Android needs a runtime grant before the map can show the blue dot.
  useEffect(() => {
    if (Platform.OS === 'android') {
      PermissionsAndroid.request(
        PermissionsAndroid.PERMISSIONS.ACCESS_FINE_LOCATION,
      ).catch(() => {});
    }
  }, []);

  const handleSwapLocations = useCallback(() => {
    setCurrentStartLocation(currentEndLocation);
    setCurrentEndLocation(currentStartLocation);
  }, [currentStartLocation, currentEndLocation]);

  const centerOnUser = useCallback(location => {
    mapRef.current?.animateCamera(
      {center: location, zoom: 16, altitude: 1200},
      {duration: 600},
    );
  }, []);

  // Like Google Maps' location button: jump to the blue dot and keep
  // following it until the user drags the map.
  const handleMyLocationPress = useCallback(() => {
    setIsFollowingUser(true);
    if (lastUserLocation.current) {
      centerOnUser(lastUserLocation.current);
      return;
    }
    Geolocation.getCurrentPosition(
      ({coords: {latitude, longitude}}) => {
        lastUserLocation.current = {latitude, longitude};
        centerOnUser(lastUserLocation.current);
      },
      () => {
        setIsFollowingUser(false);
        Toast.show({
          type: 'error',
          text1: t('root.PumpSearch.LocationUnavailable'),
        });
      },
      {enableHighAccuracy: true, timeout: 10000, maximumAge: 10000},
    );
  }, [centerOnUser, t]);

  const handleUserLocationChange = useCallback(
    ({nativeEvent: {coordinate}}) => {
      if (!coordinate) return;
      lastUserLocation.current = {
        latitude: coordinate.latitude,
        longitude: coordinate.longitude,
      };
      if (isFollowingUser) {
        mapRef.current?.animateCamera(
          {center: lastUserLocation.current},
          {duration: 500},
        );
      }
    },
    [isFollowingUser],
  );

  // Hands the trip to Google Maps (or Apple Maps) for turn-by-turn.
  const startNavigation = useCallback(() => {
    if (!currentStartLocation || !currentEndLocation) return;
    const from = `${currentStartLocation.latitude},${currentStartLocation.longitude}`;
    const to = `${currentEndLocation.latitude},${currentEndLocation.longitude}`;
    const webUrl = `https://www.google.com/maps/dir/?api=1&origin=${from}&destination=${to}&travelmode=driving`;
    const appUrl =
      Platform.OS === 'ios'
        ? `comgooglemaps://?saddr=${from}&daddr=${to}&directionsmode=driving`
        : `google.navigation:q=${to}`;
    const fallbackUrl =
      Platform.OS === 'ios'
        ? `http://maps.apple.com/?saddr=${from}&daddr=${to}&dirflg=d`
        : webUrl;
    Linking.canOpenURL(appUrl)
      .then(supported => Linking.openURL(supported ? appUrl : fallbackUrl))
      .catch(() => Linking.openURL(webUrl));
  }, [currentStartLocation, currentEndLocation]);

  // Cleanup marker refs when stations change
  useEffect(() => {
    return () => {
      // Clear marker refs when component unmounts or stations change
      markerRefs.current = {};
    };
  }, [reduxGasStations]);

  // Calculate region to show all gas stations
  const mapRegion = useMemo(() => {
    if (reduxGasStations.length === 0) {
      return {
        latitude: currentStartLocation?.latitude || 28.6139,
        longitude: currentStartLocation?.longitude || 77.209,
        latitudeDelta: 0.05,
        longitudeDelta: 0.05,
      };
    }

    const latitudes = reduxGasStations.map(station => station.location.lat);
    const longitudes = reduxGasStations.map(station => station.location.lng);

    const minLat = Math.min(...latitudes);
    const maxLat = Math.max(...latitudes);
    const minLng = Math.min(...longitudes);
    const maxLng = Math.max(...longitudes);

    const centerLat = (minLat + maxLat) / 2;
    const centerLng = (minLng + maxLng) / 2;
    const deltaLat = Math.max(maxLat - minLat, 0.01);
    const deltaLng = Math.max(maxLng - minLng, 0.01);

    return {
      latitude: centerLat,
      longitude: centerLng,
      latitudeDelta: deltaLat * 1.2,
      longitudeDelta: deltaLng * 1.2,
    };
  }, [reduxGasStations, currentStartLocation]);

  const handleRegionChangeComplete = useCallback(region => {
    visibleRegionRef.current = region;
    setVisibleRegion(region);
    setIsZoomedIn(region.latitudeDelta < DETAIL_ZOOM_DELTA);
  }, []);

  // Selected, cheapest and nearest pumps are always drawn.
  const keepMarkerKeys = useMemo(
    () =>
      [getStationKey(selectedStation), cheapestKey, nearestKey].filter(
        Boolean,
      ),
    [selectedStation, cheapestKey, nearestKey, getStationKey],
  );

  const markerStations = useMemo(
    () =>
      visibleStations(reduxGasStations, visibleRegion || mapRegion, {
        thin: !isZoomedIn,
        keepKeys: keepMarkerKeys,
        getKey: getStationKey,
      }),
    [
      reduxGasStations,
      visibleRegion,
      mapRegion,
      isZoomedIn,
      keepMarkerKeys,
      getStationKey,
    ],
  );

  const handleMarkerPress = useCallback(station => {
    // When marker is pressed, show selected station in bottom sheet
    setSelectedStation(station);
    setShowStationDetails(false);
    setShowScanReceipt(false);
    // Down to just its header, the sheet would hide the selected station.
    if (sheetIndexRef.current === 0) {
      bottomSheetRef.current?.snapToIndex(1);
    }
  }, []);

  // Markers come and go as the map moves, so refs are added and removed here
  // under every id a pump may be looked up by.
  const registerMarkerRef = useCallback((station, ref) => {
    [station.id, station.place_id, station.placeId]
      .filter(Boolean)
      .forEach(id => {
        if (ref) {
          markerRefs.current[id] = ref;
        } else if (markerRefs.current[id]) {
          delete markerRefs.current[id];
        }
      });
  }, []);

  // Function to zoom to a specific marker
  const zoomToMarker = useCallback(async station => {
    if (!mapRef.current) return;

    try {
      const coordinate = {
        latitude: station.location.lat,
        longitude: station.location.lng,
      };

      // Animate to the marker with appropriate zoom level
      mapRef.current.animateToRegion(
        {
          latitude: coordinate.latitude,
          longitude: coordinate.longitude,
          latitudeDelta: 0.01, // Zoomed in view
          longitudeDelta: 0.01,
        },
        1000,
      ); // 1 second animation
    } catch (error) {
      console.log('Error zooming to marker:', error);
    }
  }, []);

  // function to handle bookmark
  const handleBookmark = useCallback(
    async (station, type) => {
      try {
        if (type == 'save') {
          console.log('saving station', station);
          const response = await saveStation(station);
          if (response.Success) {
            const key = getStationKey(station);
            setBookmarkOverrides(prev => ({...prev, [key]: true}));
            setSelectedStation(prev => {
              if (!prev) return prev;
              return getStationKey(prev) === key
                ? {...prev, isBookmarked: true}
                : prev;
            });
            Toast.show({
              type: 'success',
              text1: response.Message,
            });
          } else {
            Toast.show({
              type: 'error',
              text1: response.Message,
            });
          }
        } else {
          console.log('removing station', station);
          const response = await removeStation(station);
          if (response.Success) {
            const key = getStationKey(station);
            setBookmarkOverrides(prev => ({...prev, [key]: false}));
            setSelectedStation(prev => {
              if (!prev) return prev;
              return getStationKey(prev) === key
                ? {...prev, isBookmarked: false}
                : prev;
            });
            Toast.show({
              type: 'success',
              text1: response.Message,
            });
          } else {
            Toast.show({
              type: 'error',
              text1: response.Message,
            });
          }
        }
      } catch (err) {
        Toast.show({
          type: 'error',
          text1:
            err.message || type == 'save'
              ? t('root.Toast.Error.FailedToSaveStation')
              : t('root.Toast.Error.FailedToRemoveStation'),
        });
      }
    },
    [dispatch, getStationKey, t],
  );

  // Function to handle marker selection from bottom sheet
  const handleStationSelection = useCallback(
    async station => {
      try {
        // First, snap bottom sheet down to the collapsed list to dismiss it
        bottomSheetRef.current?.snapToIndex(1);

        // Wait for bottom sheet to close completely, then zoom to the marker
        setTimeout(async () => {
          await zoomToMarker(station);

          // Wait for zoom animation to complete, then show callout and details
          setTimeout(() => {
            // Try multiple ID formats to find the marker ref
            const possibleIds = [
              station.id,
              station.place_id,
              station.placeId,
            ].filter(Boolean);

            let markerRef = null;
            for (const id of possibleIds) {
              if (markerRefs.current[id]) {
                markerRef = markerRefs.current[id];
                break;
              }
            }

            // If found, show the callout
            if (markerRef && typeof markerRef.showCallout === 'function') {
              markerRef.showCallout();
            }

            // Show selected station in bottom sheet when callout appears
            setSelectedStation(station);
            setShowStationDetails(false);
            setShowScanReceipt(false);
            // bottomSheetRef.current?.snapToIndex(1);
          }, 1200); // Wait for zoom animation + buffer
        }, 500); // Wait for bottom sheet to close completely
      } catch (error) {
        console.log('Error in handleStationSelection:', error);
      }
    },
    [zoomToMarker],
  );

  // Function to open external maps with directions
  const openDirections = useCallback(station => {
    const {lat, lng} = station.location;
    const label = encodeURIComponent(station.name);

    if (Platform.OS === 'ios') {
      // Try Apple Maps first, fallback to Google Maps
      const appleMapsUrl = `http://maps.apple.com/?daddr=${lat},${lng}&dirflg=d`;
      const googleMapsUrl = `comgooglemaps://?daddr=${lat},${lng}&directionsmode=driving`;
      const googleMapsWebUrl = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;

      Linking.canOpenURL(googleMapsUrl)
        .then(supported => {
          if (supported) {
            Linking.openURL(googleMapsUrl);
          } else {
            Linking.openURL(appleMapsUrl);
          }
        })
        .catch(() => {
          Linking.openURL(googleMapsWebUrl);
        });
    } else {
      // Android - try Google Maps first, fallback to web
      const googleMapsUrl = `google.navigation:q=${lat},${lng}`;
      const googleMapsWebUrl = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;

      Linking.canOpenURL(googleMapsUrl)
        .then(supported => {
          if (supported) {
            Linking.openURL(googleMapsUrl);
          } else {
            Linking.openURL(googleMapsWebUrl);
          }
        })
        .catch(() => {
          Linking.openURL(googleMapsWebUrl);
        });
    }
  }, []);

  const handleBottomSheetChange = useCallback(index => {
    console.log('Bottom sheet change:', index);
    sheetIndexRef.current = index;
    if (index === 0) {
      // Bottom sheet is down to just its header
      setSelectedStation(null);
      // Don't reset active button here - keep it active even when sheet closes
    }
  }, []);
  // console.log('loginDetails',);
  const viewAllStations = useCallback(() => {
    setSelectedStation(null);
    setShowStationDetails(false);
    setShowScanReceipt(false);
    // Note: We don't reset activeButton here - keep button active state
  }, []);

  // Handle station details view
  const handleShowStationDetails = useCallback(async station => {
    console.log('selected station in handleShowStationDetails', station);
    setSelectedStation(station);
    setShowStationDetails(true);
    setShowScanReceipt(false);
    bottomSheetRef.current?.snapToIndex(2);

    // Fetch detailed station information
    try {
      setIsLoadingStationDetails(true);
      const placeId = station.id || station.place_id || station.placeId;

      if (placeId) {
        const result = await getStationDetails(placeId);

        if (result.success) {
          setStationDetails(result.data?.Data);
          console.log('Station details fetched:', result.data?.Data);
        } else {
          console.error('Failed to fetch station details:', result.error);
          Toast.show({
            type: 'error',
            text1: t('root.Toast.Error.FailedToLoadDetails'),
            text2:
              result.error?.Message ||
              t('root.Toast.Error.CouldNotLoadStationDetails'),
          });
        }
      }
    } catch (error) {
      console.error('Error fetching station details:', error);
      Toast.show({
        type: 'error',
        text1: t('root.Toast.Error.NetworkError'),
        text2: t('root.Toast.Error.FailedToLoadStationDetails'),
      });
    } finally {
      setIsLoadingStationDetails(false);
    }
  }, []);

  // Handle scan receipt view
  const handleShowScanReceipt = useCallback(() => {
    setShowScanReceipt(true);
    setShowStationDetails(false);
  }, []);

  // Handle back from scan receipt
  const handleBackFromScan = useCallback(() => {
    setShowScanReceipt(false);
    setShowStationDetails(true);
  }, []);
  // Handle save receipt
  const handleSaveReceipt = useCallback(async () => {
    try {
      console.log('selectedStation', selectedStation);
      console.log('Saving receipt with price:', enteredPrice);

      // Validate required data
      if (!enteredPrice || !selectedStation || !userId) {
        console.error('Missing required data for price update');
        Toast.show({
          type: 'error',
          text1: t('root.Toast.Error.MissingInformation'),
          text2: t('root.Toast.Error.EnterValidPriceAndStation'),
        });
        return;
      }
      console.log('receiptUrl', receiptUrl);
      if (!receiptUrl) {
        Toast.show({
          type: 'error',
          text1: t('root.Toast.Error.PleaseUpload'),
          text2: t('root.Toast.Error.PleaseUploadReceipt'),
        });
        return;
      }

      if (!receiptFuelType) {
        Toast.show({
          type: 'error',
          text1: t('root.Toast.Error.MissingInformation'),
          text2: t('root.Toast.Error.SelectFuelType'),
        });
        return;
      }

      // Validate price format (a comma decimal, "1,85", is accepted too)
      const price = parseFloat(String(enteredPrice).replace(',', '.'));
      if (isNaN(price) || price <= 0) {
        Toast.show({
          type: 'error',
          text1: t('root.Toast.Error.InvalidPrice'),
          text2: t('root.Toast.Error.EnterValidPriceGreaterThanZero'),
        });
        return;
      }

      // Prepare API data
      const priceData = {
        placeId: stationDetails?.id,
        latestPrice: price,
        userId: userId,
        recieptUrl: receiptUrl, // Use uploaded URL or default
        fuelType: receiptFuelType,
      };

      console.log('Calling updatePrice API with data:', priceData);

      // Show loading toast
      // Toast.show({
      //   type: 'info',
      //   text1: 'Updating Price',
      //   text2: 'Please wait...',
      // });

      // Call the API
      const result = await updatePrice(priceData);

      if (result.success) {
        console.log('Price updated successfully:', result.data);

        // Show success toast
        Toast.show({
          type: 'success',
          text1: t('root.Toast.Error.PriceUpdatedSuccessfully'),
          text2: `€${price} saved for ${selectedStation.name}`,
        });

        // Prices are stale in every cached route now; reload the selected
        // one after a delay and let the others reload when picked again.
        stationCache.current.clear();
        setTimeout(() => {
          if (selectedRoute) {
            loadStationsForRoute(selectedRoute, {refresh: true});
          }
        }, 2000);

        // Reset form and close modals
        setShowScanReceipt(false);
        setShowStationDetails(false);
        setSelectedStation(null);
        setEnteredPrice('');
        setReceiptUrl('');
        setReceiptFuelType(null);
      } else {
        console.error('Failed to update price:', result.error);
        Toast.show({
          type: 'error',
          text1: t('root.Toast.Error.UpdateFailed'),
          text2:
            result.error?.Message ||
            result.error?.message ||
            t('root.Toast.Error.FailedToUpdatePrice'),
        });
      }
    } catch (error) {
      console.error('Error in handleSaveReceipt:', error);
      Toast.show({
        type: 'error',
        text1: t('root.Toast.Error.NetworkError'),
        text2: t('root.Toast.Error.CheckInternetConnection'),
      });
    }
  }, [
    enteredPrice,
    selectedStation,
    userId,
    dispatch,
    receiptUrl,
    receiptFuelType,
    stationDetails,
    selectedRoute,
    loadStationsForRoute,
    t,
  ]);

  // The receipt was sent for review (scans/extract -> scans/:id/submit). The
  // price only changes once the team approves it, so the lists are not
  // reloaded here; just close the form.
  const handleScanSubmitted = useCallback(() => {
    setShowScanReceipt(false);
    setShowStationDetails(false);
    setSelectedStation(null);
    setEnteredPrice('');
    setReceiptUrl('');
    setReceiptFuelType(null);
  }, []);

  // Loading component
  const LoadingIndicator = () => (
    <View style={styles.loadingContainer}>
      <ActivityIndicator size="large" color={colors.primary} />
      <Text style={styles.loadingText}>
        {t('root.PumpSearch.FindingGasStations')}
      </Text>
    </View>
  );

  // Station Details View Component
  const StationDetailsView = ({station, stationDetails, isLoading}) => {
    const distance = currentStartLocation
      ? calculateDistance(
          currentStartLocation.latitude,
          currentStartLocation.longitude,
          station.location.lat,
          station.location.lng,
        ).toFixed(1)
      : 'N/A';

    const handleCall = () => {
      if (stationDetails?.phone) {
        // Format phone number: remove spaces, keep only digits and +
        const phoneNumber = stationDetails.phone.replace(/[\s\-\(\)]/g, '');
        const telUrl = `tel:${phoneNumber}`;

        Linking.canOpenURL(telUrl)
          .then(supported => {
            if (supported) {
              Linking.openURL(telUrl);
            } else {
              Toast.show({
                type: 'error',
                text1: t('root.Toast.Error.CallNotSupported'),
                text2: t('root.Toast.Error.UnableToMakeCall'),
              });
            }
          })
          .catch(() => {
            // Fallback: try opening anyway
            Linking.openURL(telUrl);
          });
      } else {
        Toast.show({
          type: 'info',
          text1: t('root.Toast.Error.NoPhoneNumber'),
          text2: t('root.Toast.Error.PhoneNumberNotAvailable'),
        });
      }
    };

    const handleWebsite = () => {
      if (stationDetails?.website) {
        Linking.openURL(stationDetails.website);
      } else {
        Toast.show({
          type: 'info',
          text1: t('root.Toast.Error.NoWebsite'),
          text2: t('root.Toast.Error.WebsiteNotAvailable'),
        });
      }
    };


    if (isLoading) {
      return (
        <View style={styles.stationDetailsContainer}>
          <View style={styles.stationDetailsHeader}>
            <TouchableOpacity
              style={styles.backButton}
              activeOpacity={0.7}
              onPress={viewAllStations}>
              <ChevronLeft width={16} height={16} color={colors.primary} />
              <Text style={styles.backButtonText}>
                {t('root.PumpSearch.Back')}
              </Text>
            </TouchableOpacity>
            <Text style={styles.stationDetailsTitle}>
              {t('root.PumpSearch.LoadingDetails')}
            </Text>
          </View>
          <View style={styles.loadingContainer}>
            <ActivityIndicator size="large" color={colors.primary} />
            <Text style={styles.loadingText}>
              {t('root.PumpSearch.LoadingStationDetails')}
            </Text>
          </View>
        </View>
      );
    }

    // With a chosen fuel the station already carries the price of THAT fuel
    // (fuelMatch is only sent by gas-stations-by-fuel). The details response
    // has the latest scan of any fuel, so it must not replace it.
    const fuelAware = station?.fuelMatch !== undefined;
    const price = formatFuelPrice(
      fuelAware
        ? station.latestPrice
        : stationDetails?.latestPrice || station.latestPrice,
    );
    const fuel = fuelAware ? station.selectedFuel : null;
    // The list sends the offerings; fall back to the details response.
    const offerings = getFuelOfferings(
      station.offerings
        ? station
        : {...stationDetails, selectedFuel: station.selectedFuel},
    );
    const amenities = getAmenityLabels(
      station.amenities || station.paymentOptions ? station : stationDetails,
      t,
    );
    const priceAt = fuelAware
      ? station.createdAt
      : stationDetails?.latestPrice
      ? stationDetails.createdAt
      : station.createdAt;
    // With a chosen fuel only the station's own receipt (kept by
    // gasStationSlice when it matches this fuel's price) may be shown.
    const receipt = fuelAware
      ? receiptLink(station)
      : receiptLink(stationDetails) || receiptLink(station);
    const rating = stationDetails?.rating || station?.rating;
    const isOpen = stationDetails?.isOpen !== false;
    const detourMin =
      typeof station.detourSec === 'number'
        ? Math.round(station.detourSec / 60)
        : null;

    return (
      <View style={styles.stationDetailsContainer}>
        <View style={styles.detailsTopRow}>
          <TouchableOpacity
            style={styles.backButton}
            activeOpacity={0.7}
            onPress={viewAllStations}>
            <ChevronLeft width={16} height={16} color={colors.primary} />
            <Text style={styles.backButtonText}>
              {t('root.PumpSearch.Back')}
            </Text>
          </TouchableOpacity>
          {/* Only a receipt-backed price earns the badge */}
          {!!receipt && (
            <View style={styles.verifiedBadge}>
              <Glyph name="verified" size={14} color={colors.secondary} />
              <Text style={styles.verifiedBadgeText}>
                {t('root.PumpSearch.VerifiedPrice')}
              </Text>
            </View>
          )}
        </View>

        <View style={styles.detailsTitleRow}>
          <Text style={styles.stationDetailsTitle}>
            {stationDetails?.name || station.name}
          </Text>
          {!!rating && (
            <View style={styles.ratingPill}>
              <Text style={styles.ratingPillText}>{rating}</Text>
              <Glyph name="star" size={14} color={colors.warning} />
            </View>
          )}
        </View>
        <Text style={styles.stationDetailsAddress}>
          {stationDetails?.address ||
            station.vicinity ||
            'Address not available'}
        </Text>

        {/* Price of the user's fuel (or the latest scan) */}
        <View style={styles.priceSection}>
          {price ? (
            <>
              <View style={styles.priceInfoContainer}>
                <Text style={styles.priceSectionLabel}>
                  {fuel?.name || t('root.PumpSearch.LatestPrice')}
                </Text>
                <Text style={styles.latestPriceText}>
                  €{price}
                  <Text style={styles.latestPriceUnit}>
                    /{fuel?.unit || 'L'}
                  </Text>
                </Text>
                {!!priceAt && (
                  <View style={styles.priceAgeRow}>
                    <View style={styles.liveDot} />
                    <Text style={styles.priceTimeText}>
                      {getTimeAgo(priceAt, t)}
                    </Text>
                  </View>
                )}
              </View>
              {!!receipt && (
                <TouchableOpacity
                  style={styles.viewReceiptButton}
                  activeOpacity={0.8}
                  onPress={() => openReceiptViewer(receipt)}>
                  <Text style={styles.viewReceiptButtonText}>
                    {t('root.PumpSearch.ViewReceipt')}
                  </Text>
                </TouchableOpacity>
              )}
            </>
          ) : (
            <Text style={styles.noPriceText}>
              {t('root.PumpSearch.NoPriceYet')}
            </Text>
          )}
        </View>

        {/* Action tiles; Call and Website only when the station has them */}
        <View style={styles.actionButtonsContainer}>
          <TouchableOpacity
            style={[styles.actionButton, styles.driveTimeButton]}
            activeOpacity={0.8}
            onPress={() => openDirections(station)}>
            <View style={[styles.actionIcon, styles.actionIconPrimary]}>
              <Glyph name="directions" size={18} color={colors.onPrimary} />
            </View>
            <Text style={[styles.actionButtonText, styles.driveTimeButtonText]}>
              {t('root.PumpSearch.DirectionsText')}
            </Text>
          </TouchableOpacity>

          {stationDetails?.phone && (
            <TouchableOpacity
              style={styles.actionButton}
              activeOpacity={0.8}
              onPress={handleCall}>
              <View style={styles.actionIcon}>
                <Glyph name="call" size={18} color={colors.text} />
              </View>
              <Text style={styles.actionButtonText}>
                {t('root.PumpSearch.Call')}
              </Text>
            </TouchableOpacity>
          )}

          {stationDetails?.website && (
            <TouchableOpacity
              style={styles.actionButton}
              activeOpacity={0.8}
              onPress={handleWebsite}>
              <View style={styles.actionIcon}>
                <Glyph name="website" size={18} color={colors.text} />
              </View>
              <Text style={styles.actionButtonText}>
                {t('root.PumpSearch.Website')}
              </Text>
            </TouchableOpacity>
          )}
        </View>

        <FuelPriceList
          offerings={offerings}
          formatAge={ms => getTimeAgo(ms, t)}
        />

        {/* Hours · Distance · Detour (detour only when the backend sends it) */}
        <View style={styles.infoDisplayContainer}>
          <View style={styles.infoItem}>
            <Text style={styles.infoLabel}>{t('root.PumpSearch.HOURS')}</Text>
            <Text
              style={[
                styles.infoValue,
                isOpen ? styles.openStatus : styles.closedStatus,
              ]}>
              {isOpen ? t('root.PumpSearch.Open') : t('root.PumpSearch.Closed')}
            </Text>
          </View>

          <View style={[styles.infoItem, styles.infoItemDivided]}>
            <Text style={styles.infoLabel}>
              {t('root.PumpSearch.DISTANCE')}
            </Text>
            <Text style={styles.infoValue}>
              {alongRouteText(station) || `${distance} km`}
            </Text>
          </View>

          {detourMin !== null && (
            <View style={[styles.infoItem, styles.infoItemDivided]}>
              <Text style={styles.infoLabel}>
                {t('root.PumpSearch.DETOUR')}
              </Text>
              <Text style={styles.infoValue}>
                {t('root.PumpSearch.DetourMinutes', {count: detourMin})}
              </Text>
            </View>
          )}
        </View>

        {amenities.length > 0 && (
          <View style={styles.detailsAmenities}>
            <Text style={styles.detailsSectionLabel}>
              {t('root.PumpSearch.AmenitiesTitle')}
            </Text>
            <View style={styles.detailsAmenityChips}>
              {amenities.map(label => (
                <View key={label} style={styles.detailsAmenityChip}>
                  <Text style={styles.detailsAmenityChipText}>{label}</Text>
                </View>
              ))}
            </View>
          </View>
        )}

        <PrimaryButton
          title={t('root.PumpSearch.ScanReceipt')}
          icon={<Glyph name="scan" size={20} color={colors.onPrimary} />}
          onPress={handleShowScanReceipt}
        />
        <Text style={styles.scanReceiptText}>
          {t('root.PumpSearch.ScanReceiptText')}
        </Text>
      </View>
    );
  };

  const renderBackdrop = useCallback(
    props => (
      <BottomSheetBackdrop
        {...props}
        // Only the expanded sheet dims the map; header-only and collapsed
        // leave it usable.
        disappearsOnIndex={1}
        appearsOnIndex={2}
        // Tapping the dimmed map drops the sheet back to the collapsed list.
        // The default ('close') hid the sheet with no way to bring it back.
        pressBehavior={1}
      />
    ),
    [],
  );

  // Header button handlers
  const handleCheapestPress = useCallback(() => {
    const cheapest =
      cheapestKey &&
      displayedGasStations.find(s => getStationKey(s) === cheapestKey);
    if (cheapest) {
      setActiveButton('cheapest');
      handleStationSelection(cheapest);
    } else {
      Toast.show({
        type: 'info',
        text1: t('root.Toast.Error.NoCheapestStationFound'),
      });
    }
  }, [
    cheapestKey,
    displayedGasStations,
    getStationKey,
    handleStationSelection,
    t,
  ]);

  const handleNearestPress = useCallback(() => {
    if (!currentStartLocation) {
      Toast.show({
        type: 'info',
        text1: t('root.Toast.Error.SelectStartLocationFirst'),
      });
      return;
    }
    if (!reduxGasStations || reduxGasStations.length === 0) {
      Toast.show({
        type: 'info',
        text1: t('root.Toast.Error.NoStationsAvailable'),
      });
      return;
    }

    if (nearestStation) {
      setActiveButton('nearest');
      handleStationSelection(nearestStation);
    } else {
      Toast.show({
        type: 'info',
        text1: t('root.Toast.Error.CouldNotDetermineNearestStation'),
      });
    }
  }, [
    currentStartLocation,
    reduxGasStations,
    nearestStation,
    handleStationSelection,
    t,
  ]);

  // Reset handler
  const handleReset = useCallback(() => {
    // Reset active button state
    setActiveButton(null);

    // Clear selected station
    setSelectedStation(null);
    setShowStationDetails(false);
    setShowScanReceipt(false);

    // Close bottom sheet
    bottomSheetRef.current?.snapToIndex(1);

    // Hide all callouts
    Object.values(markerRefs.current).forEach(markerRef => {
      if (markerRef && typeof markerRef.hideCallout === 'function') {
        markerRef.hideCallout();
      }
    });

    // Zoom out to the whole trip
    if (routeOptions.length > 0) {
      fitRoute();
    } else if (mapRef.current && mapRegion) {
      mapRef.current.animateToRegion(mapRegion, 1000);
    }
  }, [mapRegion, routeOptions, fitRoute]);

  const renderGasStationItem = ({item: station, index}) => {
    const key = getStationKey(station);
    return (
      <StationListItem
        station={station}
        isCheapest={!!cheapestKey && key === cheapestKey}
        isNearest={!!nearestKey && key === nearestKey}
        isSelected={index === -1}
        onPress={handleShowStationDetails}
        onDirections={openDirections}
        onBookmark={handleBookmark}
        onViewReceipt={openReceiptViewer}
      />
    );
  };

  // Function to handle start location selection
  const handleStartLocationPress = useCallback(() => {
    // navigation.navigate('SearchScreen', {
    //   onSelectLocation: location => {
    //     setCurrentStartLocation(location);
    //     // console.log('Start location selected:', location);
    //   },
    // });
    navigation.goBack();
  }, [navigation]);

  // Function to handle destination selection
  const handleDestinationPress = useCallback(() => {
    // navigation.navigate('SearchScreen', {
    //   onSelectLocation: location => {
    //     setCurrentEndLocation(location);
    //     // console.log('Destination selected:', location);
    //   },
    // });
    navigation.goBack();
  }, [navigation]);

  return (
    <GestureHandlerRootView
      style={styles.container}
      onLayout={e => setContainerHeight(e.nativeEvent.layout.height)}>
      <View
        style={[styles.headerContainer, {top: insets.top + spacing.margin}]}>
        <View style={styles.header}>
          <TouchableOpacity
            style={styles.headerBackButton}
            activeOpacity={0.7}
            hitSlop={8}
            accessibilityRole="button"
            accessibilityLabel={t('root.PumpSearch.Back')}
            onPress={() => navigation.goBack()}>
            <ChevronLeft width={20} height={20} color={colors.primary} />
          </TouchableOpacity>
          <View style={styles.headerContent}>
            <View style={styles.locationRow}>
              <View style={styles.iconColumn}>
                <View style={styles.originDot} />
                <View style={styles.routeConnector}>
                  <View style={styles.routeDash} />
                  <View style={styles.routeDash} />
                  <View style={styles.routeDash} />
                  <View style={styles.routeDash} />
                </View>
                <View style={styles.destinationDot} />
              </View>
              <View style={styles.textColumn}>
                <TouchableOpacity
                  style={styles.locationContainer}
                  activeOpacity={0.6}
                  onPress={handleStartLocationPress}>
                  <Text
                    style={[
                      styles.locationText,
                      !currentStartLocation?.name && styles.locationPlaceholder,
                    ]}
                    numberOfLines={1}>
                    {currentStartLocation?.name ||
                      t('root.PumpSearch.SelectStartLocation')}
                  </Text>
                </TouchableOpacity>

                <View style={styles.divider} />

                <TouchableOpacity
                  style={styles.locationContainer}
                  activeOpacity={0.6}
                  onPress={handleDestinationPress}>
                  <Text
                    style={[
                      styles.locationText,
                      !currentEndLocation?.name && styles.locationPlaceholder,
                    ]}
                    numberOfLines={1}>
                    {currentEndLocation?.name ||
                      t('root.PumpSearch.SelectDestination')}
                  </Text>
                </TouchableOpacity>
              </View>
              <TouchableOpacity
                style={styles.swapButton}
                activeOpacity={0.6}
                hitSlop={8}
                accessibilityRole="button"
                accessibilityLabel={t('root.PumpSearch.SwapLocations')}
                disabled={!currentStartLocation || !currentEndLocation}
                onPress={handleSwapLocations}>
                <SwapIcon width={20} height={20} color={colors.primary} />
              </TouchableOpacity>
            </View>
            <View style={styles.headerButtons}>
              <TouchableOpacity
                style={[
                  styles.headerButton,
                  activeButton === 'cheapest' && styles.headerButtonActive,
                ]}
                activeOpacity={0.8}
                onPress={handleCheapestPress}>
                {activeButton === 'cheapest' && <View style={styles.chipDot} />}
                <Text
                  style={[
                    styles.headerButtonText,
                    activeButton === 'cheapest' && styles.headerButtonTextActive,
                  ]}>
                  {t('root.PumpSearch.Cheapest')}
                </Text>
              </TouchableOpacity>
              <TouchableOpacity
                style={[
                  styles.headerButton,
                  activeButton === 'nearest' && styles.headerButtonActive,
                ]}
                activeOpacity={0.8}
                onPress={handleNearestPress}>
                {activeButton === 'nearest' && <View style={styles.chipDot} />}
                <Text
                  style={[
                    styles.headerButtonText,
                    activeButton === 'nearest' && styles.headerButtonTextActive,
                  ]}>
                  {t('root.PumpSearch.Nearest')}
                </Text>
              </TouchableOpacity>
              <TouchableOpacity
                style={styles.resetButton}
                activeOpacity={0.8}
                onPress={handleReset}>
                <Text style={styles.resetButtonText}>
                  {t('root.PumpSearch.Reset') || 'Reset'}
                </Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </View>

      <MapView
        ref={mapRef}
        style={styles.map}
        showsPointsOfInterest={true}
        showsCompass={true}
        showsUserLocation={true}
        showsMyLocationButton={false}
        rotateEnabled={true}
        pitchEnabled={true}
        initialRegion={mapRegion}
        onUserLocationChange={handleUserLocationChange}
        onRegionChangeComplete={handleRegionChangeComplete}
        onPanDrag={() => isFollowingUser && setIsFollowingUser(false)}>
        {/* Route options: alternatives underneath, selected on top */}
        {routeOptions.map((routeOption, index) =>
          index === selectedRouteIndex ? null : (
            <Polyline
              key={`${routeOption.id}-alt`}
              coordinates={routeOption.coordinates}
              strokeColor={ALT_ROUTE_COLOR}
              strokeWidth={ROUTE_WIDTH}
              lineCap="round"
              lineJoin="round"
              tappable
              onPress={() => setSelectedRouteIndex(index)}
              zIndex={1}
            />
          ),
        )}
        {selectedRoute && (
          <Polyline
            key={`${selectedRoute.id}-outline`}
            coordinates={selectedRoute.coordinates}
            strokeColor={colors.primaryDeep}
            strokeWidth={ROUTE_OUTLINE_WIDTH}
            lineCap="round"
            lineJoin="round"
            zIndex={2}
          />
        )}
        {selectedRoute && (
          <Polyline
            key={`${selectedRoute.id}-line`}
            coordinates={selectedRoute.coordinates}
            strokeColor={colors.secondary}
            strokeWidth={ROUTE_WIDTH}
            lineCap="round"
            lineJoin="round"
            zIndex={3}
          />
        )}

        {/* Travel-time bubbles, one per route */}
        {routeOptions.map((routeOption, index) => {
          const point = routeLabelPoints[index];
          if (!point) return null;
          const selected = index === selectedRouteIndex;
          return (
            <Marker
              key={`${routeOption.id}-label-${selected}`}
              coordinate={point}
              anchor={{x: 0.5, y: 1}}
              tracksViewChanges={false}
              zIndex={selected ? 60 : 50}
              onPress={() => setSelectedRouteIndex(index)}>
              <View
                style={[
                  styles.routeLabel,
                  selected && styles.routeLabelSelected,
                ]}>
                <Text
                  style={[
                    styles.routeLabelText,
                    selected && styles.routeLabelTextSelected,
                  ]}
                  numberOfLines={1}>
                  {routeOption.durationText}
                </Text>
              </View>
            </Marker>
          );
        })}

        {/* Start and End markers */}
        {currentStartLocation && (
          <Marker
            coordinate={{
              latitude: currentStartLocation.latitude,
              longitude: currentStartLocation.longitude,
            }}
            zIndex={70}
            title={currentStartLocation.name || t('root.PumpSearch.StartLocation')}
            description={
              currentStartLocation.name ? t('root.PumpSearch.StartLocation') : undefined
            }>
            <StartMarker width={27} height={43} />
          </Marker>
        )}

        {currentEndLocation && (
          <Marker
            coordinate={{
              latitude: currentEndLocation.latitude,
              longitude: currentEndLocation.longitude,
            }}
            zIndex={70}
            title={currentEndLocation.name || t('root.PumpSearch.EndLocation')}
            description={
              currentEndLocation.name ? t('root.PumpSearch.EndLocation') : undefined
            }>
            <DefaultMarker width={27} height={43} />
          </Marker>
        )}

        {/* Gas station markers: off-screen pumps are skipped and, zoomed
            out with many in view, overlapping pumps show only the cheapest
            (utility/visibleStations). */}
        {markerStations.map((gasStation, index) => {
          const key = getStationKey(gasStation);
          return (
            <StationMarker
              key={`${key || index}-${isZoomedIn ? 'pin' : 'dot'}`}
              station={gasStation}
              isZoomedIn={isZoomedIn}
              isCheapest={!!cheapestKey && key === cheapestKey}
              isNearest={!!nearestKey && key === nearestKey}
              onPress={handleMarkerPress}
              registerRef={registerMarkerRef}
            />
          );
        })}
      </MapView>

      {/* Floating map controls, riding just above the sheet */}
      <Animated.View
        style={[styles.mapControls, mapControlsStyle]}
        pointerEvents="box-none">
        {routeOptions.length > 0 && (
          <TouchableOpacity
            style={styles.mapControlButton}
            activeOpacity={0.8}
            accessibilityRole="button"
            accessibilityLabel={t('root.PumpSearch.RouteOverview')}
            onPress={() => fitRoute()}>
            <Glyph name="overview" size={22} color={colors.text} />
          </TouchableOpacity>
        )}
        <TouchableOpacity
          style={styles.mapControlButton}
          activeOpacity={0.8}
          accessibilityRole="button"
          accessibilityLabel={t('root.PumpSearch.MyLocation')}
          onPress={handleMyLocationPress}>
          <Glyph
            name="myLocation"
            size={22}
            color={isFollowingUser ? colors.secondary : colors.text}
          />
        </TouchableOpacity>
      </Animated.View>

      <BottomSheet
        ref={bottomSheetRef}
        index={1}
        snapPoints={snapPoints}
        animatedPosition={sheetPosition}
        animatedIndex={sheetAnimatedIndex}
        onChange={handleBottomSheetChange}
        backgroundStyle={[styles.bottomSheetBackground]}
        handleIndicatorStyle={styles.bottomSheetIndicator}
        backdropComponent={renderBackdrop}
        // enablePanDownToClose={true}
        enableDynamicSizing={false}>
        <View style={styles.bottomSheetWrapper}>
          <View
            style={styles.bottomSheetHeader}
            onLayout={e =>
              setSheetHeaderHeight(Math.ceil(e.nativeEvent.layout.height))
            }>
            {/* Selected route summary, Google-Maps style */}
            <View style={styles.routeSummary}>
              <Glyph name="car" size={26} color={colors.text} />
              <View style={styles.routeSummaryInfo}>
                {isLoadingRoutes ? (
                  <ActivityIndicator size="small" color={colors.secondary} />
                ) : selectedRoute ? (
                  <>
                    <Text style={styles.routeSummaryTitle} numberOfLines={1}>
                      <Text
                        style={
                          selectedRoute.hasDelay
                            ? styles.routeDurationDelayed
                            : styles.routeDuration
                        }>
                        {selectedRoute.durationText}
                      </Text>
                      {`  ·  ${selectedRoute.distanceText}`}
                    </Text>
                    {!!selectedRoute.summary && (
                      <Text style={styles.routeInfo} numberOfLines={1}>
                        {selectedRouteIndex === 0
                          ? `${t('root.PumpSearch.Fastest')} · `
                          : ''}
                        {t('root.PumpSearch.Via', {
                          summary: selectedRoute.summary,
                        })}
                      </Text>
                    )}
                  </>
                ) : (
                  <Text style={styles.routeInfo}>
                    {routeError
                      ? t('root.PumpSearch.RouteError')
                      : t('root.PumpSearch.NoRoute')}
                  </Text>
                )}
              </View>
              {selectedRoute && (
                <TouchableOpacity
                  style={styles.startButton}
                  activeOpacity={0.85}
                  accessibilityRole="button"
                  onPress={startNavigation}>
                  <Glyph name="navigate" size={18} color={colors.onPrimary} />
                  <Text style={styles.startButtonText}>
                    {t('root.PumpSearch.Start')}
                  </Text>
                </TouchableOpacity>
              )}
            </View>
            <Text style={styles.stationsCount}>
              {isLoadingGasStations
                ? t('root.PumpSearch.Searching')
                : `${t('root.PumpSearch.GasStations')} (${
                    reduxGasStations.length
                  })`}
            </Text>
          </View>
          {/* Fades out at the header-only snap point, so no half-hidden
              card peeks out below the header. */}
          <Animated.View style={[styles.bottomSheetBody, sheetBodyStyle]}>
          {!isLoadingGasStations && !selectedStation ? (
            // The full list is virtualised: only rows near the screen exist.
            <BottomSheetFlatList
              data={displayedGasStations}
              keyExtractor={(station, index) =>
                String(getStationKey(station) || index)
              }
              renderItem={renderGasStationItem}
              contentContainerStyle={[
                styles.bottomSheetContent,
                styles.stationsList,
                sheetBottomPadding,
              ]}
              ListEmptyComponent={
                selectedRoute ? (
                  <Text style={styles.noStationsText}>
                    {t('root.PumpSearch.NoStationsOnRoute')}
                  </Text>
                ) : null
              }
              initialNumToRender={8}
              maxToRenderPerBatch={8}
              windowSize={7}
              removeClippedSubviews={Platform.OS === 'android'}
              showsVerticalScrollIndicator={true}
              style={{maxHeight: screenHeight * 0.75}}
            />
          ) : (
          <BottomSheetScrollView
            contentContainerStyle={[
              styles.bottomSheetContent,
              sheetBottomPadding,
            ]}
            showsVerticalScrollIndicator={true}
            nestedScrollEnabled={true}
            bounces={true}
            scrollEventThrottle={16}
            style={{maxHeight: screenHeight * 0.75}}>
            {isLoadingGasStations ? (
              <LoadingIndicator />
            ) : showScanReceipt && selectedStation ? (
              <ScanReceiptView
                station={selectedStation}
                distanceText={
                  alongRouteText(selectedStation) ||
                  (currentStartLocation
                    ? formatDistance(
                        calculateDistance(
                          currentStartLocation.latitude,
                          currentStartLocation.longitude,
                          selectedStation.location.lat,
                          selectedStation.location.lng,
                        ) * 1000,
                      )
                    : null)
                }
                enteredPrice={enteredPrice}
                setEnteredPrice={setEnteredPrice}
                handleBackFromScan={handleBackFromScan}
                onSubmitted={handleScanSubmitted}
              />
            ) : showStationDetails && selectedStation ? (
              <StationDetailsView
                station={selectedStation}
                stationDetails={stationDetails}
                isLoading={isLoadingStationDetails}
              />
            ) : selectedStation ? (
              <View style={styles.selectedStationContainer}>
                <View style={styles.selectedStationHeader}>
                  <Text style={styles.selectedStationTitle}>
                    {t('root.PumpSearch.SelectedStation')}
                  </Text>
                  <TouchableOpacity
                    style={styles.viewAllButton}
                    activeOpacity={0.7}
                    onPress={viewAllStations}>
                    <Text style={styles.viewAllButtonText}>
                      {t('root.PumpSearch.ViewAllStations')}
                    </Text>
                  </TouchableOpacity>
                </View>
                {renderGasStationItem({item: selectedStation, index: -1})}
              </View>
            ) : null}
          </BottomSheetScrollView>
          )}
          </Animated.View>
        </View>
      </BottomSheet>

      <ReceiptViewerModal
        url={receiptViewerUrl}
        onClose={closeReceiptViewer}
      />
    </GestureHandlerRootView>
  );
};

// On iOS a custom marker view is centred on its coordinate, so a spacer
// below the pin balances the price bubble above it. Android anchors the
// view's bottom-centre, so no spacer is needed there.
const markerBalance = Platform.select({
  ios: {paddingBottom: PRICE_BUBBLE_HEIGHT + spacing.xs},
  default: {},
});

// Chip inside a card
const cardChip = {
  height: 32,
  flexDirection: 'row',
  alignItems: 'center',
  paddingHorizontal: spacing.md,
  borderRadius: radii.pill,
  backgroundColor: colors.surfaceMuted,
  borderWidth: 1,
  borderColor: colors.surfaceMuted,
};


const statusTag = {
  ...typography.labelMd,
  borderRadius: radii.pill,
  overflow: 'hidden',
  paddingHorizontal: 10,
  paddingVertical: 2,
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.background,
  },

  // Floating route header (Level 2 over the map)
  headerContainer: {
    position: 'absolute',
    left: 0,
    right: 0,
    zIndex: 1000,
    backgroundColor: 'transparent',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: 'transparent',
  },
  headerBackButton: {
    width: 44,
    height: 44,
    borderRadius: 22,
    marginLeft: spacing.margin,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: colors.glass,
    borderWidth: 1,
    borderColor: colors.border,
    ...shadows.level2,
  },
  headerContent: {
    flex: 1,
    marginLeft: spacing.sm,
    marginRight: spacing.margin,
    paddingVertical: spacing.xs,
    paddingHorizontal: spacing.margin,
    backgroundColor: colors.glass,
    borderRadius: radii.card,
    borderWidth: 1,
    borderColor: colors.border,
    ...shadows.level2,
    zIndex: 1000,
  },
  locationRow: {
    flexDirection: 'row',
    alignItems: 'stretch',
  },
  iconColumn: {
    width: 16,
    alignItems: 'center',
    marginRight: spacing.md,
    paddingTop: 14,
    paddingBottom: 14,
  },
  // Same colours as the start (green) and end (red) pins on the map
  originDot: {
    width: 14,
    height: 14,
    borderRadius: 7,
    borderWidth: 3,
    borderColor: colors.secondary,
    backgroundColor: colors.surface,
  },
  destinationDot: {
    width: 14,
    height: 14,
    borderRadius: 7,
    borderWidth: 2,
    borderColor: colors.surface,
    backgroundColor: MAP_END_RED,
    ...shadows.level1,
  },
  routeConnector: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'space-between',
    marginVertical: spacing.xs,
  },
  routeDash: {
    width: 2,
    height: 3,
    borderRadius: 1,
    backgroundColor: colors.secondary,
  },
  textColumn: {
    flex: 1,
  },
  locationContainer: {
    height: 44,
    justifyContent: 'center',
  },
  locationText: {
    ...typography.bodyMd,
    color: colors.text,
  },
  locationPlaceholder: {
    color: colors.textMuted,
  },
  divider: {
    height: 1,
    backgroundColor: colors.border,
  },
  swapButton: {
    width: 36,
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: spacing.xs,
  },

  // Quick-filter chips, inside the route card below a divider
  headerButtons: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: spacing.sm,
    paddingTop: spacing.md,
    paddingBottom: spacing.sm,
    borderTopWidth: 1,
    borderTopColor: colors.border,
  },
  headerButton: {
    ...cardChip,
  },
  headerButtonActive: {
    backgroundColor: colors.primary,
    borderColor: colors.primary,
  },
  chipDot: {
    width: 6,
    height: 6,
    borderRadius: 3,
    backgroundColor: colors.secondary,
    marginRight: 6,
  },
  headerButtonText: {
    ...typography.labelMd,
    color: colors.text,
  },
  headerButtonTextActive: {
    color: colors.onPrimary,
  },
  resetButtonSpacer: {
    flex: 1,
  },
  resetButton: {
    ...cardChip,
    backgroundColor: 'transparent',
    borderColor: colors.border,
  },
  resetButtonText: {
    ...typography.labelMd,
    color: colors.textMuted,
  },

  map: {
    flex: 1,
    marginTop: 0,
  },

  // Station pin + price bubble (fixed size — see PIN_* constants)
  stationMarker: {
    width: PIN_STACK_WIDTH,
    alignItems: 'center',
    ...markerBalance,
  },
  priceBubble: {
    height: PRICE_BUBBLE_HEIGHT,
    maxWidth: PIN_STACK_WIDTH,
    paddingHorizontal: 6,
    marginBottom: spacing.xs,
    borderRadius: radii.badge,
    backgroundColor: colors.primary,
    alignItems: 'center',
    justifyContent: 'center',
  },
  priceBubbleCheapest: {
    backgroundColor: CHEAPEST_RED,
  },
  priceBubbleEmpty: {
    backgroundColor: 'transparent',
  },
  priceBubbleText: {
    ...typography.labelSm,
    color: colors.onPrimary,
  },
  // The pin artwork carries its own ring; cheapest / nearest get a halo.
  stationPin: {
    borderRadius: PIN_SIZE,
    backgroundColor: colors.surface,
    ...shadows.level2,
  },
  stationPinCheapest: {
    padding: 3,
    backgroundColor: CHEAPEST_RED,
    ...shadows.level3,
  },
  stationPinNearest: {
    padding: 3,
    backgroundColor: colors.secondary,
  },

  // Map callout
  mapCalloutContainer: {
    width: 240,
    backgroundColor: colors.surface,
    borderRadius: radii.badge,
  },
  mapCalloutHeader: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  mapCalloutLogo: {
    width: 28,
    height: 28,
    borderRadius: 14,
    backgroundColor: colors.mintSoft,
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: spacing.sm,
  },
  mapCalloutInfo: {
    flex: 1,
    flexShrink: 1,
  },
  mapCalloutTitle: {
    ...typography.labelLg,
    color: colors.text,
    marginBottom: 2,
  },
  mapCalloutAddress: {
    ...typography.bodySm,
    color: colors.textMuted,
  },

  // Bottom sheet
  bottomSheetBackground: {
    backgroundColor: colors.surface,
    borderTopLeftRadius: radii.sheet,
    borderTopRightRadius: radii.sheet,
    ...shadows.level2,
    shadowOffset: {width: 0, height: -8},
  },
  bottomSheetIndicator: {
    backgroundColor: colors.border,
    width: 40,
    height: 4,
    borderRadius: 2,
  },
  bottomSheetWrapper: {
    flex: 1,
  },
  bottomSheetBody: {
    flex: 1,
  },
  bottomSheetContent: {
    paddingBottom: spacing.xxl,
    flexGrow: 1,
  },
  bottomSheetHeader: {
    paddingHorizontal: spacing.lg,
    paddingTop: spacing.xs,
    paddingBottom: spacing.md,
    borderBottomWidth: 1,
    borderBottomColor: colors.borderSubtle,
  },
  bottomSheetTitle: {
    ...typography.headlineSm,
    color: colors.text,
    marginBottom: 2,
  },
  routeInfo: {
    ...typography.labelMd,
    color: colors.textMuted,
  },
  routeSummary: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.md,
    minHeight: 48,
  },
  routeSummaryInfo: {
    flex: 1,
    alignItems: 'flex-start',
  },
  routeSummaryTitle: {
    ...typography.headlineSm,
    color: colors.text,
  },
  routeDuration: {
    color: colors.brandBright,
  },
  routeDurationDelayed: {
    color: colors.onWarningContainer,
  },
  startButton: {
    flexDirection: 'row',
    alignItems: 'center',
    height: 40,
    paddingHorizontal: spacing.margin,
    borderRadius: radii.pill,
    backgroundColor: colors.primary,
    gap: 6,
  },
  startButtonText: {
    ...typography.labelLg,
    color: colors.onPrimary,
  },
  stationsCount: {
    ...typography.labelLg,
    color: colors.text,
    marginTop: spacing.md,
  },
  noStationsText: {
    ...typography.bodyMd,
    color: colors.textMuted,
    textAlign: 'center',
    paddingVertical: spacing.lg,
  },

  // Route travel-time bubbles on the map
  routeLabel: {
    paddingHorizontal: 10,
    paddingVertical: 4,
    borderRadius: radii.badge,
    backgroundColor: colors.surface,
    borderWidth: 1,
    borderColor: colors.border,
  },
  routeLabelSelected: {
    backgroundColor: colors.primary,
    borderColor: colors.primary,
  },
  routeLabelText: {
    ...typography.labelLg,
    color: colors.text,
  },
  routeLabelTextSelected: {
    color: colors.onPrimary,
  },

  // Zoomed-out pin: same halos as stationPin*, thinner to suit the size
  stationDotCheapest: {
    padding: 2,
    backgroundColor: CHEAPEST_RED,
  },
  stationDotNearest: {
    padding: 2,
    backgroundColor: colors.secondary,
  },

  // Floating map buttons (overview, my location)
  mapControls: {
    position: 'absolute',
    right: spacing.margin,
    gap: spacing.md,
    alignItems: 'flex-end',
  },
  mapControlButton: {
    width: 48,
    height: 48,
    borderRadius: 24,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: colors.surface,
    ...shadows.level2,
  },

  // Station list
  // contentContainerStyle of the list, so no flex: 1 (it would stop scrolling)
  stationsList: {
    paddingHorizontal: spacing.lg,
    paddingTop: spacing.sm,
  },
  selectedStationContainer: {
    paddingHorizontal: spacing.lg,
    paddingTop: spacing.margin,
  },
  selectedStationHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: spacing.xs,
  },
  selectedStationTitle: {
    ...typography.labelLg,
    color: colors.text,
    flexShrink: 1,
    marginRight: spacing.sm,
  },
  viewAllButton: {
    height: 32,
    paddingHorizontal: spacing.md,
    borderRadius: radii.pill,
    backgroundColor: colors.mintSoft,
    justifyContent: 'center',
  },
  viewAllButtonText: {
    ...typography.labelMd,
    color: colors.primary,
  },
  stationItem: {
    ...card,
    marginVertical: spacing.sm,
    padding: spacing.margin,
  },
  stationItemCheapest: {
    borderWidth: 1.5,
    borderColor: colors.primary,
  },
  stationItemNearest: {
    borderWidth: 1.5,
    borderColor: colors.secondary,
  },
  stationItemSelected: {
    borderWidth: 2,
    borderColor: colors.secondary,
    backgroundColor: colors.mintTint,
    // Flat when selected: Android elevation bleeds through a tinted fill.
    shadowOpacity: 0,
    elevation: 0,
  },
  cheapestButton: {
    height: 24,
    paddingHorizontal: 10,
    borderRadius: radii.pill,
    backgroundColor: colors.mintSoft,
    justifyContent: 'center',
  },
  cheapestButtonText: {
    ...typography.labelSm,
    color: colors.secondary,
    textTransform: 'uppercase',
  },
  nearestButton: {
    height: 24,
    paddingHorizontal: 10,
    borderRadius: radii.pill,
    backgroundColor: colors.surfaceMuted,
    justifyContent: 'center',
  },
  nearestButtonText: {
    ...typography.labelSm,
    color: colors.primary,
    textTransform: 'uppercase',
  },
  priceTimeText: {
    ...typography.bodySm,
    color: colors.textMuted,
  },
  // Station card
  cardHeader: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: spacing.md,
  },
  cardAvatar: {
    width: 52,
    height: 52,
    borderRadius: radii.sm + 4,
    backgroundColor: colors.brandBright,
    alignItems: 'center',
    justifyContent: 'center',
  },
  cardAvatarText: {
    ...typography.headlineLg,
    color: colors.onPrimary,
  },
  cardTitleBlock: {
    flex: 1,
  },
  cardTitleRow: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  cardName: {
    ...typography.headlineSm,
    fontFamily: fonts.bold,
    color: colors.text,
    flexShrink: 1,
  },
  cardBadges: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: spacing.xs,
  },
  cardBadge: {
    marginTop: spacing.xs,
    paddingHorizontal: spacing.sm,
    paddingVertical: 2,
    borderRadius: radii.badge,
    backgroundColor: colors.mintSoft,
  },
  cardBadgeNeutral: {
    backgroundColor: colors.surfaceMuted,
  },
  cardBadgeText: {
    ...typography.labelSm,
    color: colors.brandBright,
    textTransform: 'uppercase',
  },
  cardBadgeTextNeutral: {
    color: colors.primary,
  },
  cardSubtitle: {
    ...typography.bodyMd,
    color: colors.textMuted,
    marginTop: spacing.xs,
  },
  cardAhead: {
    fontFamily: fonts.semiBold,
    color: colors.brandBright,
  },
  cardSavePill: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.xs,
    paddingHorizontal: spacing.md,
    paddingVertical: 6,
    borderRadius: radii.sm,
    backgroundColor: colors.surfaceMuted,
  },
  cardSavePillActive: {
    backgroundColor: colors.mintSoft,
  },
  cardSavePillText: {
    ...typography.labelMd,
    color: colors.primary,
  },
  cardRating: {
    ...typography.labelLg,
    color: colors.text,
    alignSelf: 'flex-end',
    marginTop: spacing.xs,
  },
  cardRatingStar: {
    color: colors.warning,
  },
  cardPanel: {
    flexDirection: 'row',
    marginTop: spacing.md,
    paddingVertical: spacing.md,
    borderRadius: radii.sm + 4,
    borderWidth: 1,
    borderColor: colors.border,
    backgroundColor: colors.background,
  },
  cardPanelCol: {
    flex: 1,
    paddingHorizontal: spacing.md,
    alignItems: 'flex-start',
  },
  cardPanelDivider: {
    width: 1,
    backgroundColor: colors.border,
  },
  cardPanelLabel: {
    ...typography.labelSm,
    color: colors.textSubtle,
    textTransform: 'uppercase',
  },
  cardPanelValue: {
    ...typography.headlineSm,
    color: colors.text,
    marginTop: 2,
  },
  cardPanelValueMuted: {
    color: colors.textSubtle,
  },
  cardPanelValueLive: {
    color: colors.brandBright,
  },
  cardPanelUnit: {
    ...typography.bodySm,
    color: colors.textMuted,
  },
  cardPanelChip: {
    marginTop: spacing.xs,
    paddingHorizontal: spacing.sm,
    paddingVertical: 2,
    borderRadius: radii.badge,
    backgroundColor: colors.mintSoft,
  },
  cardPanelChipText: {
    ...typography.labelSm,
    color: colors.brandBright,
  },
  cardPanelSub: {
    ...typography.bodySm,
    color: colors.textMuted,
    marginTop: spacing.xs,
  },
  cardAmenities: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    columnGap: spacing.lg,
    rowGap: spacing.xs,
    marginTop: spacing.md,
    paddingHorizontal: spacing.xs,
  },
  cardAmenityText: {
    ...typography.bodyMd,
    color: colors.textEmphasis,
  },
  cardActions: {
    flexDirection: 'row',
    gap: spacing.md,
    marginTop: spacing.margin,
  },
  cardButton: {
    height: 48,
    borderRadius: radii.pill,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: spacing.margin,
  },
  cardButtonSecondary: {
    flex: 1,
    backgroundColor: colors.surfaceMuted,
  },
  cardButtonSecondaryText: {
    ...typography.labelLg,
    color: colors.text,
  },
  cardButtonPrimary: {
    flex: 1.6,
    backgroundColor: colors.primary,
  },
  cardButtonPrimaryText: {
    ...typography.labelLg,
    color: colors.onPrimary,
  },

  // Loading
  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: spacing.xxl,
    paddingHorizontal: spacing.lg,
  },
  loadingText: {
    ...typography.bodyMd,
    color: colors.textMuted,
    marginTop: spacing.margin,
    textAlign: 'center',
  },

  // Station details
  stationDetailsContainer: {
    paddingHorizontal: spacing.lg,
    paddingVertical: spacing.margin,
  },
  stationDetailsHeader: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: spacing.md,
    marginBottom: spacing.xs,
  },
  backButton: {
    flexDirection: 'row',
    alignItems: 'center',
    height: 32,
    paddingLeft: spacing.sm,
    paddingRight: spacing.md,
    borderRadius: radii.pill,
    backgroundColor: colors.surfaceMuted,
    gap: 2,
  },
  backButtonText: {
    ...typography.labelMd,
    color: colors.primary,
  },
  stationDetailsTitle: {
    ...typography.headlineSm,
    color: colors.text,
    flexShrink: 1,
  },
  stationDetailsAddress: {
    ...typography.bodyMd,
    color: colors.textMuted,
    marginTop: spacing.xs,
    marginBottom: spacing.margin,
  },
  detailsTopRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: spacing.md,
  },
  verifiedBadge: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.xs,
    height: 28,
    paddingHorizontal: spacing.sm,
    borderRadius: radii.pill,
    backgroundColor: colors.mintWash,
    borderWidth: 1,
    borderColor: colors.mintLine,
  },
  verifiedBadgeText: {
    ...typography.labelMd,
    color: colors.brandLink,
  },
  detailsTitleRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: spacing.sm,
  },
  ratingPill: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 2,
    height: 28,
    paddingHorizontal: spacing.sm,
    borderRadius: radii.pill,
    backgroundColor: colors.surfaceMuted,
  },
  ratingPillText: {
    ...typography.labelLg,
    color: colors.text,
  },
  priceSection: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: spacing.md,
    padding: spacing.margin,
    backgroundColor: colors.background,
    borderRadius: radii.card,
    borderWidth: 1,
    borderColor: colors.borderSubtle,
  },
  priceInfoContainer: {
    flex: 1,
  },
  latestPriceText: {
    ...typography.headlineLg,
    color: colors.primary,
    marginVertical: 2,
  },
  latestPriceUnit: {
    ...typography.labelMd,
    color: colors.textMuted,
  },
  priceSectionLabel: {
    ...typography.labelSm,
    color: colors.textMuted,
    textTransform: 'uppercase',
  },
  priceAgeRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.xs,
  },
  liveDot: {
    width: 6,
    height: 6,
    borderRadius: 3,
    backgroundColor: colors.secondary,
  },
  noPriceText: {
    ...typography.bodyMd,
    color: colors.textMuted,
    flex: 1,
  },
  viewReceiptButton: {
    height: 36,
    paddingHorizontal: spacing.margin,
    borderRadius: radii.pill,
    backgroundColor: colors.primary,
    justifyContent: 'center',
    marginLeft: spacing.md,
  },
  viewReceiptButtonText: {
    ...typography.labelMd,
    color: colors.onPrimary,
  },
  actionButtonsContainer: {
    flexDirection: 'row',
    alignItems: 'stretch',
    gap: spacing.sm,
    marginBottom: spacing.md,
  },
  actionButton: {
    flex: 1,
    paddingVertical: spacing.md,
    paddingHorizontal: spacing.sm,
    borderRadius: radii.card,
    borderWidth: 1,
    borderColor: colors.border,
    backgroundColor: colors.surface,
    alignItems: 'center',
    justifyContent: 'center',
  },
  driveTimeButton: {
    backgroundColor: colors.mintWash,
    borderColor: colors.mintLine,
  },
  actionIcon: {
    width: 36,
    height: 36,
    borderRadius: 18,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: colors.surfaceMuted,
  },
  actionIconPrimary: {
    backgroundColor: colors.primary,
  },
  actionButtonText: {
    ...typography.labelMd,
    color: colors.text,
    marginTop: spacing.sm,
    textAlign: 'center',
  },
  driveTimeButtonText: {
    color: colors.primary,
  },
  infoDisplayContainer: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    paddingVertical: spacing.md,
    marginBottom: spacing.lg,
    backgroundColor: colors.background,
    borderRadius: radii.card,
    borderWidth: 1,
    borderColor: colors.borderSubtle,
  },
  infoItem: {
    flex: 1,
    alignItems: 'center',
  },
  infoItemDivided: {
    borderLeftWidth: 1,
    borderLeftColor: colors.border,
  },
  infoLabel: {
    ...typography.labelSm,
    color: colors.textMuted,
    marginBottom: spacing.sm,
    textTransform: 'uppercase',
    textAlign: 'center',
  },
  infoValue: {
    ...typography.labelLg,
    color: colors.text,
  },
  openStatus: {
    ...statusTag,
    color: colors.secondary,
    backgroundColor: colors.mintSoft,
  },
  closedStatus: {
    ...statusTag,
    color: colors.error,
    backgroundColor: colors.errorContainer,
  },
  detailsAmenities: {
    marginBottom: spacing.lg,
  },
  detailsSectionLabel: {
    ...typography.labelSm,
    color: colors.textSubtle,
    textTransform: 'uppercase',
    marginBottom: spacing.sm,
  },
  detailsAmenityChips: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: spacing.sm,
  },
  detailsAmenityChip: {
    paddingHorizontal: spacing.md,
    paddingVertical: 6,
    borderRadius: radii.pill,
    backgroundColor: colors.surfaceMuted,
  },
  detailsAmenityChipText: {
    ...typography.labelMd,
    color: colors.textEmphasis,
  },
  scanReceiptText: {
    ...typography.bodySm,
    color: colors.textMuted,
    marginTop: spacing.md,
    textAlign: 'center',
  },
});

export default MapPumpSearch;